import React from "react"

const CirclesIcon = () => {
  return (
    <svg viewBox="0 0 163 163" fill="white" xmlns="http://www.w3.org/2000/svg">
      <circle cx="67" cy="67" r="60" stroke="black" strokeWidth="15"/>
      <circle cx="110.5" cy="110.5" r="45.5" stroke="black" strokeWidth="15"/>
    </svg>
  )
}

export default CirclesIcon
